var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStayTunedFileSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 80,
    viewBox: "0 0 62 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7646 42.2939L46.8823 42.2939",
    stroke: "#C8D0E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7646 56.0586L33.1176 56.0586",
    stroke: "#C8D0E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H36.7118C37.0787 1 37.2621 1 37.4347 1.04145C37.5878 1.07819 37.7341 1.1388 37.8683 1.22104C38.0197 1.3138 38.1494 1.44352 38.4088 1.70294L59.9441 23.2382C60.2035 23.4977 60.3333 23.6274 60.426 23.7787C60.5083 23.913 60.5689 24.0593 60.6056 24.2123C60.6471 24.385 60.6471 24.5684 60.6471 24.9353V76.6C60.6471 77.4401 60.6471 77.8601 60.4836 78.181C60.3398 78.4632 60.1103 78.6927 59.828 78.8365C59.5072 79 59.0871 79 58.2471 79H3.4C2.55992 79 2.13988 79 1.81901 78.8365C1.53677 78.6927 1.3073 78.4632 1.16349 78.181C1 77.8601 1 77.4401 1 76.6V3.4Z",
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3701 1.38965H38.0501L60.6701 24.3996V28.2996L33.3701 28.6896V1.38965Z",
    fill: "#C8D0E5",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1177 1V26.1294C33.1177 26.9695 33.1177 27.3895 33.2812 27.7104C33.425 27.9926 33.6544 28.2221 33.9367 28.3659C34.2576 28.5294 34.6776 28.5294 35.5177 28.5294H60.6471",
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayTunedFileSmall);
export default __webpack_public_path__ + "static/media/stay-tuned-file-small.afea2554541db429799c7eaa36e8b1ca.svg";
export { ForwardRef as ReactComponent };